import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const REGISTER_LINK = 'https://www.jaiclub37.com/#/register?invitationCode=22188109813';

const openRegistrationLink = () => {
  window.open(REGISTER_LINK, '_blank', 'noopener,noreferrer');
};

// Header section component
const HeroHeader = () => (
  <div className="text-center mb-8">
    <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Login</h1>
    
    <div className="flex items-center justify-center gap-3 md:gap-4 mb-8">
      <Button
        onClick={openRegistrationLink}
        variant="outline"
        className="text-sm md:text-base px-6 md:px-8 py-3 border-2 border-blue-500 text-blue-400 bg-transparent hover:bg-blue-500/10 transition-all duration-300 hover:scale-105 font-semibold"
      >
        Register
      </Button>
      <Button
        onClick={openRegistrationLink}
        className="text-sm md:text-base px-6 md:px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white transition-all duration-300 hover:scale-105 shadow-md hover:shadow-lg hover:shadow-blue-500/50 font-semibold"
      >
        Login Now
      </Button>
    </div>
  </div>
);

// Proof image component
const ProofImage = ({ src, alt }) => (
  <div className="relative group overflow-hidden rounded-2xl shadow-lg shadow-blue-500/20 hover:shadow-2xl hover:shadow-blue-500/40 transition-all duration-500 transform hover:scale-105 border border-gray-800">
    <img
      src={src}
      alt={alt}
      className="w-full h-64 md:h-80 object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-blue-600/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  </div>
);

// Images grid component
const ProofImagesGrid = () => (
  <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-8">
    <ProofImage 
      src="https://jalwaaamazingg.site.pro/gallery_gen/7bebaffece7a7bcf26b426c97c1683af_fit.webp?ts=1770386928"
      alt="Proof 2"
    />
    <ProofImage 
      src="https://jalwaaamazingg.site.pro/gallery_gen/161b1a46b5aee0a2ae1938305946e718_fit.webp?ts=1770386928"
      alt="Proof 1"
    />
  </div>
);

// Call to action component
const CallToAction = () => (
  <div className="text-center max-w-3xl mx-auto bg-gradient-to-br from-gray-900 to-black rounded-2xl shadow-lg shadow-blue-500/20 p-8 md:p-10 border border-gray-800">
    <p className="text-lg md:text-xl text-gray-300 mb-6 leading-relaxed">
      Quick access to your dashboard. Track rewards, explore events, and stay ahead of the curve.
    </p>
    <Button
      onClick={openRegistrationLink}
      size="lg"
      className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg shadow-blue-500/50 hover:shadow-xl hover:shadow-blue-500/70 group"
    >
      Login
      <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
    </Button>
  </div>
);

const HeroSection = () => {
  return (
    <section className="py-12 md:py-20 px-4 bg-black">
      <div className="container mx-auto max-w-6xl">
        <HeroHeader />
        <ProofImagesGrid />
        <CallToAction />
      </div>
    </section>
  );
};

export default HeroSection;
